import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { setAnalyticsUser } from './analytics'

export const deriveBrandFromHost = (host?: string): string => {
  if (!host) return 'jyrney'
  const h = host.toLowerCase()
  if (h.includes('veezu')) return 'veezu'
  if (h.includes('tysers')) return 'tysers'
  if (h.includes('reedmackay')) return 'reedmackay'
  if (h.includes('takeme')) return 'takeme'
  if (h.includes('easthouse')) return 'easthouse'
  if (h.includes('advantage')) return 'advantage'
  if (h.includes('runyourfleet')) return 'runyourfleet'
  return 'jyrney'
}

const pickRole = (user: any): string | undefined => {
  const roles = user?.roles
  if (Array.isArray(roles) && roles.length) return String(roles[0])
  if (typeof roles === 'string' && roles) return roles
  if (user?.role) return String(user.role)
  return undefined
}

export default function useAnalyticsIdentity() {
  const user = useSelector((s: any) => s?.users?.user)
  const client = useSelector((s: any) => s?.clients?.client)

  useEffect(() => {
    const host =
      typeof window !== 'undefined' ? window.location?.hostname : undefined
    setAnalyticsUser({
      user_role: pickRole(user),
      client_id: client?.id,
      client_name: client?.companyName,
      brand: deriveBrandFromHost(host),
    })
  }, [user, client?.id, client?.companyName])
}
